import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { EASE } from "@/components/site/motion";

export const Preloader = ({ onDone }) => {
  const [n, setN] = useState(0);

  useEffect(() => {
    let raf = 0;
    let timer = 0;
    const start = performance.now();
    const dur = 1250;
    const step = (now) => {
      const k = Math.min((now - start) / dur, 1);
      setN(Math.round((1 - Math.pow(1 - k, 3)) * 1025));
      if (k < 1) raf = requestAnimationFrame(step);
      else timer = setTimeout(onDone, 260);
    };
    raf = requestAnimationFrame(step);
    return () => {
      cancelAnimationFrame(raf);
      clearTimeout(timer);
    };
  }, [onDone]);

  return (
    <motion.div
      className="fixed inset-0 z-[100] flex flex-col justify-between bg-ink px-5 py-6 sm:px-10 sm:py-10"
      exit={{ clipPath: "inset(0 0 100% 0)" }}
      initial={{ clipPath: "inset(0 0 0% 0)" }}
      transition={{ duration: 1, ease: EASE }}
      data-testid="preloader"
    >
      <div className="flex justify-between eyebrow text-fg-3">
        <span>Autonomous cargo ships</span>
        <span className="hidden sm:inline">Crew onboard: 0</span>
      </div>
      <div className="flex items-end justify-between gap-6">
        <span className="font-[600] leading-[0.78] tracking-[-0.06em] text-[24vw] sm:text-[17vw] text-fg">
          <span className="font-[380]">x</span>
          {String(n).padStart(4, "0")}
        </span>
        <span className="mb-[2vw] hidden h-2.5 w-2.5 rounded-full bg-signal pulse-dot sm:block" />
      </div>
    </motion.div>
  );
};
